<i
  [attr.data-testId]="testId"
  [attr.title]="infoText | localize"
  class="fa fa-info-circle"></i>
